import AbstractAuthenticatedService from '@vertical-plus/vue-js-micro-service-components/lib/model/service/abstract-authenticated-service';
import GetOmnisearchResultsTask from '@/model/task/search/get-omnisearch-results-task';
import OmnisearchResultsVo from '@/model/vo/search/omnisearch-results-vo';

export default class OmnisearchService extends AbstractAuthenticatedService
{
    /**
     * Returns search results
     *
     * @params searchTerm
     *
     * @returns
     */

    public async search(searchTerm: string): Promise<OmnisearchResultsVo>
    {
        const task = new GetOmnisearchResultsTask();
        task.token = this.token;
        task.searchTerm = searchTerm;

        return this.runTask(task) as Promise<OmnisearchResultsVo>;
    }
}